import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { headingStyles, paragraph, paragraphStyles } from '@helpers/typography';
import { DropdownStyles } from '@stories/Components/Dropdown/Dropdown.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
import BreadcrumbStyles from '../Global/Breadcrumb/Breadcrumb.styles';
import { PageTheme } from '@helpers/themeEnum';
const BannerArea = styled.div `

  --widgetThemeColor: var(--primaryPageThemeColorTint);
  --innerBgColor: ${rgba(brand.blue.light, 0.8)};

  [data-page-theme=${PageTheme.Orange}] & {
    --widgetThemeColor: ${brand.orange.tint};
    --innerBgColor: ${rgba(brand.orange.light, 0.8)};
  }

  [data-page-theme=${PageTheme.Green}] & {
    --widgetThemeColor: ${brand.green.tint};
    --innerBgColor: ${rgba(brand.green.light, 0.8)};
  }

  [data-page-theme=${PageTheme.Blue}] & {
    --widgetThemeColor: ${brand.blue.tint};
    --innerBgColor: ${rgba(brand.blue.light, 0.8)};
  }

  [data-page-theme=${PageTheme.Yellow}] & {
    --widgetThemeColor: ${brand.yellow.tint};
    --innerBgColor: ${rgba(brand.yellow.light, 0.8)};
  }

  background-color: var(--widgetThemeColor);
  padding-top: calc(${fluid(60, 120)} + var(--notificationBarHeight, 0px));
  position: relative;
  /* z-index: 7; */

  ${BreadcrumbStyles.Container} {
    padding-top: ${fluid(30, 42)};
    padding-bottom: ${fluid(30, 42)};
    position: relative;
  }
`;
const AnimationArea = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
const BgAnimation = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  svg {
    width: 100%;
    height: 100%;
    color: var(--primaryPageThemeColor);
  }
`;
const BgAnimationMobile = styled.div `
  position: absolute;
  top: -10%;
  right: 0;
  width: auto;
  height: 100%;
  transform: translateX(20%);


  @media ${from(Device.TabletLarge)} {
    display: none;
  }

  svg {
    width: 425px;
    height: 637px;
    color: var(--primaryPageThemeColor);
  }
`;
const Container = styled(SectionWrapper) `
  /* z-index: 1; */
`;
const ListingContainer = styled(SectionWrapper) `
  z-index: 0;
`;
const BannerInner = styled.div `
  background-color: var(--innerBgColor);
  padding: ${fluid(30, 64)} ${fluid(16, 40)};
  border-radius: ${fluid(25, 50)};
`;
const Title = styled.h1 `
  ${headingStyles};

  font-size: ${fluid(35, 70)};
  line-height: ${fluid(47, 80)};
`;
const Intro = styled.p `
  ${paragraphStyles};
  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  max-width: 710px;
  margin-left: auto;
  margin-right: auto;
`;
const BannerSearchArea = styled.div `
  text-align: center;
`;
const SearchInputHolder = styled.div `
  padding-bottom: ${fluid(24, 64)};
  width: 100%;
  max-width: 550px;
  position: relative;
  margin: auto;
`;
const SearchInputLabel = styled.label `
  ${srOnly};
`;
const SearchInput = styled.input `
  ${fonts.montserrat.regular};
  display: block;
  appearance: none;
  border: 1px solid ${brand.grey.grey80};
  border-radius: 80000000px;
  background-color: ${brand.white};
  color: ${brand.black};
  font-size: 18px;
  line-height: 34px;
  width: 100%;
  height: 60px;
  padding: 0 30px;
`;
const SearchSubmit = styled.button `
  ${transition('background-color, border-color')};
  position: absolute;
  top: 0;
  right: 0;
  margin-left: 10px;
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${brand.grey.grey80};
  border-radius: 1000000px;
  background-color: ${brand.white};

  &:hover,
  &:focus {
    background-color: ${brand.green.base};
    border-color: ${brand.green.base};
  }

  svg {
    height: 26px;
  }
`;
const FilterArea = styled.div ``;
const FeaturedArea = styled.div `
  margin: ${fluid(32, 56)} 0 ${fluid(40, 65)};
`;
const Listing = styled.div `
  ${baseGrid};
  grid-template-columns: 1fr;
  row-gap: ${fluid(40, 72)};
  margin-top: ${fluid(32, 56)};

  @media ${from(Device.TabletSmall)} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const ListingTotals = styled.div `
  flex-shrink: 0;
`;
const ListingTotalsText = styled.p `
  ${paragraph};
  ${fonts.montserrat.medium};
  margin-bottom: 0;
  text-align: center;

  @media ${from(Device.TabletSmall)} {
    text-align: initial;
  }
`;
const PaginationContainer = styled.div `
  @media ${until(Device.TabletSmall)} {
    padding: 0;
    margin: 30px 0;
  }

  > div {
    margin: 0;
  }

  ul {
    place-content: flex-end;

    li.previous {
      @media ${until(Device.TabletSmall)} {
        flex: 1 0 auto;
      }
    }

    li.next {
      @media ${until(Device.TabletSmall)} {
        flex: 1 0 auto;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  
`;
const Top = styled.div `
  display: flex;
  flex-direction: row;
  place-items: center;
  place-content: space-between;
  padding-top: ${fluid(30, 60)};

  @media ${until(Device.TabletLarge)} {
    text-align: center;

    ${DropdownStyles.Container} {
      display: none;
    }
  }

  ${DropdownStyles.Select} {
    width: 236px;
  }
`;
const Bottom = styled.div `
  display: flex;
  flex-direction: column;
  padding-top: ${fluid(0, 80)};
  padding-bottom: ${fluid(30, 60)};

  @media ${from(Device.TabletSmall)} {
    flex-direction: row-reverse;
    place-items: center;
    place-content: space-between;
    margin-bottom: 0;
  }
`;
export const BlogListingStyles = {
    AnimationArea,
    BannerArea,
    BannerInner,
    BannerSearchArea,
    BgAnimation,
    BgAnimationMobile,
    Bottom,
    Container,
    FeaturedArea,
    FilterArea,
    Intro,
    Listing,
    ListingContainer,
    ListingTotals,
    ListingTotalsText,
    PaginationContainer,
    SearchInput,
    SearchInputHolder,
    SearchInputLabel,
    SearchSubmit,
    Title,
    Top,
};
